import React from 'react';

/**
 * Table skeleton rows — Phase 9.
 *
 * Renders `rows` × `columns` shimmering placeholders inside a <tbody>.
 * Use INSIDE a <table> so column widths line up with headers already
 * defined by the parent.
 */
export function TableRowSkeleton({ rows = 6, columns = 5, testId = 'table-skeleton' }) {
    return (
        <>
            {Array.from({ length: rows }).map((_, r) => (
                <tr key={r} data-testid={`${testId}-row`}>
                    {Array.from({ length: columns }).map((__, c) => (
                        <td key={c} className="px-3 py-3">
                            <div className="h-4 rounded bg-[#F5F6FA] overflow-hidden relative">
                                <span className="absolute inset-0 block animate-shimmer bg-gradient-to-r from-transparent via-white to-transparent" />
                            </div>
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );
}

/**
 * Compact block skeleton for non-table use (e.g. KPI cards, chart bodies).
 * Props: className passthrough for width/height sizing.
 */
export function BlockSkeleton({ className = 'h-6 w-full', testId }) {
    return (
        <div data-testid={testId} className={`rounded bg-[#F5F6FA] overflow-hidden relative ${className}`}>
            <span className="absolute inset-0 block animate-shimmer bg-gradient-to-r from-transparent via-white to-transparent" />
        </div>
    );
}
